import { render, staticRenderFns } from "./BiSectionPage.vue?vue&type=template&id=61d43ffa&scoped=true"
import script from "./BiSectionPage.vue?vue&type=script&lang=ts"
export * from "./BiSectionPage.vue?vue&type=script&lang=ts"
import style0 from "./BiSectionPage.vue?vue&type=style&index=0&id=61d43ffa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d43ffa",
  null
  
)

export default component.exports